// import components
import { Dialog } from 'components/shared';

// import styles
import { styled } from '@mui/material';

export const StyledDialogMedium = styled(Dialog)(() => ({
  '& .MuiPaper-root': {
    minWidth: 550
  }
}));

export const StyledDialogFullWidth = styled(Dialog)(() => ({
  '& .MuiPaper-root': {
    width: '100%'
  }
}));

export const StyledDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: theme.shape.borderRadius
  }
}));
